import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';

@Injectable({
  providedIn: 'root',
})
export class ClientOrderDatesService {
  datePipe :DatePipe;

  constructor(private featureToggleService :FeatureToggleService) {
    this.datePipe = new DatePipe('en');
  }

  parseDatetimeString(dateString :string) :string {
    return DateTime.fromISO(dateString, {
      zone: 'utc',
    }).toISODate();
  }

  parseDatetimeStringToISOString(dateString :string, sourceTime ?:Date) :string {
    return DateTime.fromISO(dateString, {
      zone: 'utc',
    }).toISO();
  }

  transformToDatetimeString(datetimeStr :Date, format ?:string) :string {
    if (!format) {
      format = 'mediumDate';
    }

    return this.datePipe.transform(datetimeStr, format, 'UTC');
  }
}
